import { ulid } from "ulid";
const ULID_RE = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/** Generate a new lexicographically sortable unique id. */
export function newId() {
    return ulid();
}
export function isUlid(value) {
    return ULID_RE.test(value);
}
export function isUuid(value) {
    return UUID_RE.test(value);
}
/** True for ULID or legacy UUID entity ids. */
export function isEntityId(value) {
    return isUlid(value) || isUuid(value);
}
//# sourceMappingURL=id.js.map